
import React, { useEffect, useState } from "react";
import axios from "axios";
import ObtieneDatosCookies from '../tools/obtieneDatosCookiesUsuario.js';
const API_UPLOAD = "https://wwwa.isepsantafe.net.ar/expedientes/movimientos/upload";
const API_GET = "https://wwwa.isepsantafe.net.ar/expedientes/movimientos/devuelve-archivos";
const API_DELETE = "https://wwwa.isepsantafe.net.ar/expedientes/movimientos/elimina-archivos";

const UploadArchivosMovimiento = ({ movimiento_id,refrezca }) => {
  const [files, setFiles] = useState([]);
  const [archivosGuardados, setArchivosGuardados] = useState([]);
  const [dragOver, setDragOver] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState("");
const Usuario=ObtieneDatosCookies()
  // ===============================
  // 🔥 TRAER ARCHIVOS
  // ===============================
  const fetchArchivos = async () => {
    try {
      const res = await axios.post(API_GET, { movimiento_id });
      setArchivosGuardados(res.data?.archivos || []);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (movimiento_id) fetchArchivos();
  }, [movimiento_id]);

  // ===============================
  // 📥 NUEVOS ARCHIVOS
  // ===============================
  const handleFiles = (selectedFiles) => {
    const nuevos = Array.from(selectedFiles);
const tiposPermitidos = [
  "application/pdf",
  "image/jpeg",
  "image/png",

  // Excel
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",

  // Word
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];
    const validos = nuevos.filter((file) =>
  tiposPermitidos.includes(file.type)
);

    setFiles((prev) => [...prev, ...validos]);
  };

  const handleChange = (e) => handleFiles(e.target.files);

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    handleFiles(e.dataTransfer.files);
  };

  // ===============================
  // ⬆️ SUBIR
  // ===============================
  const handleUpload = async () => {
    if (!files.length) return;

    setLoading(true);
    setMensaje("");

    try {
      const formData = new FormData();
      formData.append("movimiento_id", movimiento_id);
      formData.append("usuario", Usuario.identificacion);

      files.forEach((file) => {
        formData.append("archivos", file);
      });

      const operacion=await axios.post(API_UPLOAD, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
// console.log(operacion)
      setMensaje("✅ Archivos subidos correctamente");
      setFiles([]);
      
      fetchArchivos();
      if (refrezca) refrezca(); // 🔥 esto actualiza todo el expediente
    } catch (error) {
      console.error(error);
      setMensaje("❌ Error al subir archivos");
    } finally {
      setLoading(false);
    }
  };

  // ===============================
  // ❌ ELIMINAR
  // ===============================
  const handleDelete = async (archivo_id) => {

  if (!window.confirm("¿Eliminar archivo?")) return;

  try {

    setLoading(true);

    await axios.post(API_DELETE, {
      archivo_id,
      usuario: Usuario.identificacion,
    });

    await fetchArchivos();

  } catch (error) {

    console.error(error);
    alert("Error al eliminar");

  } finally {

    setLoading(false);

  }

};
  const removeFile = (index) => {
    const nuevos = [...files];
    nuevos.splice(index, 1);
    setFiles(nuevos);
  };

  // ===============================
  // 👁️ PREVIEW
  // ===============================
const renderPreview = (file) => {
  const url = file.url.startsWith("http")
    ? file.url
    : `https://wwwa.isepsantafe.net.ar${file.url}`;

  const tipo = file.tipo || "";
  const nombre = file.nombre || "";

  // 🖼️ IMÁGENES (VER ONLINE)
  if (tipo.startsWith("image/")) {
    return (
      <img
        src={url}
        alt={nombre}
        style={{
          maxWidth: "100%",
          maxHeight: "300px",
          borderRadius: 8,
          marginTop: 5,
          border: "1px solid #ccc",
        }}
      />
    );
  }

  // 📄 PDF (VER ONLINE)
  if (tipo === "application/pdf") {
    return (
      <iframe
        src={url}
        width="100%"
        height="500px"
        style={{ border: "1px solid #ccc", borderRadius: 8 }}
      />
    );
  }

  // 📝 WORD (DESCARGA)
  if (
    tipo === "application/msword" ||
    tipo === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
    nombre.endsWith(".doc") ||
    nombre.endsWith(".docx")
  ) {
    return (
      <a href={url} target="_blank" rel="noreferrer" download>
        📝 Descargar Word
      </a>
    );
  }

  // 📊 EXCEL (DESCARGA)
  if (
    tipo === "application/vnd.ms-excel" ||
    tipo === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
    nombre.endsWith(".xls") ||
    nombre.endsWith(".xlsx")
  ) {
    return (
      <a href={url} target="_blank" rel="noreferrer" download>
        📊 Descargar Excel
      </a>
    );
  }

  // 📎 OTROS
  return (
    <a href={url} target="_blank" rel="noreferrer" download>
      📎 Descargar archivo
    </a>
  );
};

  return (
    <div style={styles.container}>
      <h4>📂 Archivos del movimiento #{movimiento_id}</h4>

      {/* 📁 ARCHIVOS GUARDADOS */}
      {archivosGuardados.length > 0 && (
        <div style={styles.lista}>
          <h5>Archivos subidos</h5>

          {archivosGuardados.map((file) => (
            <div key={file.id} style={styles.fileItem}>
              <div style={{ width: "100%" }}>
                <strong>📄 {file.nombre}</strong>
                {renderPreview(file)}
              </div>

              {!file.bloqueado && (
                <button onClick={() => handleDelete(file.id)}>❌</button>
              )}
            </div>
          ))}
        </div>
      )}

      {/* 📥 DROP ZONE */}
      <div
        style={{
          ...styles.dropZone,
          background: dragOver ? "#e3f2fd" : "#fafafa",
        }}
        onDragOver={(e) => {
          e.preventDefault();
          setDragOver(true);
        }}
        onDragLeave={() => setDragOver(false)}
        onDrop={handleDrop}
      >
        <p>Arrastrá archivos o hacé click</p>
        <input
  type="file"
  multiple
  accept=".pdf,.jpg,.jpeg,.png,.xls,.xlsx,.doc,.docx"
  onChange={handleChange}
  style={styles.input}
/>
      </div>

      {/* 🆕 ARCHIVOS NUEVOS */}
      {files.length > 0 && (
        <div style={styles.lista}>
          <h5>Archivos a subir</h5>

          {files.map((file, idx) => (
            <div key={idx} style={styles.fileItem}>
              <span>{file.name}</span>
              <button onClick={() => removeFile(idx)}>❌</button>
            </div>
          ))}
        </div>
      )}

      {/* 🚀 BOTÓN */}
      <button
        onClick={handleUpload}
        disabled={loading || files.length === 0}
        style={styles.button}
      >
        {loading ? "Subiendo..." : "Subir archivos"}
      </button>

      {mensaje && <p>{mensaje}</p>}
    </div>
  );
};

const styles = {
  container: {
    border: "1px solid #ddd",
    padding: 15,
    borderRadius: 10,
    maxWidth: 600,
  },
  dropZone: {
    border: "2px dashed #aaa",
    padding: 30,
    textAlign: "center",
    borderRadius: 10,
    cursor: "pointer",
    position: "relative",
    marginTop: 10,
  },
  input: {
    position: "absolute",
    width: "100%",
    height: "100%",
    opacity: 0,
    top: 0,
    left: 0,
    cursor: "pointer",
  },
  lista: {
    marginTop: 15,
  },
  fileItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    background: "#eee",
    padding: 10,
    borderRadius: 8,
    marginBottom: 10,
  },
  button: {
    marginTop: 15,
    padding: "10px 15px",
    borderRadius: 8,
    border: "none",
    background: "#1976d2",
    color: "#fff",
    cursor: "pointer",
  },
};

export default UploadArchivosMovimiento;

